module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_IS-9dd1a7e2b450f0c5614b03d061eaeb33.svg";